import { Checkbox } from '@arco-design/web-react'
import { memo } from 'react'
import styled from 'styled-components'

const ZWContract = memo(({ setAgree }) => {
  return <Root>
    <Checkbox defaultChecked={true} onChange={e => setAgree(e)}>已阅读并同意下协议：
      <a className="underline"
         href="https://zhenwoai.com/agree.html">隐私政策</a>、
      <a className="underline"
         href="https://zhenwoai.com/conceal.html">用户协议</a>
    </Checkbox>
  </Root>
})

export default ZWContract

const Root = styled.div`
  display: flex;
  align-items: flex-end;
  width: 90%;
  height: 50px;
  padding-bottom: 15px;
`